import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import HeaderAndSidenav from "./Layouts/HeaderAndSidenav";
import Login from "./Pages/Login";
import Dashboard from "./Pages/Dashboard";
import TransferPoints from "./Pages/TransferPoints";
import IdPasswordChange from "./Pages/IdPasswordChange";
import PlayerSecurity from "./Pages/PlayerSecurity";
import TurnoverReport from "./Pages/TurnoverReport";
import PlayerHistory from "./Pages/PlayerHistory";
import ResultHistory from "./Pages/ResultHistory";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PrivateRoute from "./PrivateRouter";
import PayoutOptions from "./Pages/PayoutOptions";
import GMHome from "./Pages/GameManager/GMHome";
import SetGameResult from "./Pages/GameManager/SetGameResult";
import UPIPaymentRequests from "./Pages/UPIPaymentRequests";
import MacIdApprovals from "./Pages/MacIdApprovals";
import GlobalCalls from "./Globals/GlobalCalls";
import AllAccounts from "./Pages/AllAccounts";
import AccountCreation from "./Pages/AccountCreation";
import ProtectedRoute from "./Components/ProtectiveRoute";
import AccountEdit from "./Pages/AccountEdit";
import SocketConnection from "./Globals/SocketConnection";
import BetHistory from "./Pages/BetHistory";
import { getDashboardRole } from "./Globals/dashboardRoles";

function App() {
	const account = JSON.parse(localStorage.getItem("account"));
	const dashboardRole = getDashboardRole(window.location.pathname);
	const { sendMessage } = SocketConnection({
		username: account?.username,
		level: account?.level,
	});

	return (
		<BrowserRouter basename={dashboardRole ? `/${dashboardRole.path}` : undefined}>
			<Routes>
				<Route path="/login" element={<Login requiredLevel={dashboardRole?.level} roleName={dashboardRole?.name} />} />
				<Route element={<PrivateRoute requiredLevel={dashboardRole?.level} />}>
					<Route path="/" element={<HeaderAndSidenav />}>
						<Route index element={<Dashboard />} />
						{/* All Account Routes */}
						<Route element={<ProtectedRoute requiredLevel={0} />}>
							<Route path="all-players" element={<AllAccounts pageName={"All Players"} sendMessage={sendMessage} />} />
							<Route path="all-super-stokez" element={<AllAccounts pageName={"All Super Stokist"} sendMessage={sendMessage} />} />
						</Route>
						<Route element={<ProtectedRoute requiredLevel={2} />}>
							<Route path="all-stokez" element={<AllAccounts pageName={"All Stokist"} sendMessage={sendMessage} />} />
						</Route>
						<Route element={<ProtectedRoute requiredLevel={3} />}>
							<Route path="all-master" element={<AllAccounts pageName={"All Master"} sendMessage={sendMessage} />} />
						</Route>
						<Route element={<ProtectedRoute requiredLevel={4} />}>
							<Route path="all-agents" element={<AllAccounts pageName={"All Agents"} sendMessage={sendMessage} />} />
							<Route path="create-account" element={<AccountCreation />} />
							<Route path="edit-account" element={<AccountEdit />} />
							<Route path="transfer-points" element={<TransferPoints sendMessage={sendMessage} />} />
						</Route>
						<Route element={<ProtectedRoute requiredLevel={5} />}>
							<Route path="all-users" element={<AllAccounts pageName={"All Users"} sendMessage={sendMessage} />} />
						</Route>
						{/* All Account Routes */}
						{/* Account Edit Routes */}
						<Route element={<ProtectedRoute requiredLevel={0} />}>
							<Route path="id-password-change" element={<IdPasswordChange />} />
							<Route path="player-security" element={<PlayerSecurity />} />
						</Route>
						{/* Account Edit Routes */}
						{/* Game / Result Settings Route */}
						<Route element={<ProtectedRoute requiredLevel={0} />}>
							<Route path="game-manager" element={<GMHome />} />
							<Route path="set-result" element={<SetGameResult />} />
							<Route path="playout-mode" element={<PayoutOptions />} />
							<Route path="macid-approvals" element={<MacIdApprovals />} />
						</Route>
						{/* Game / Result Settings Route */}
						<Route path="player-history" element={<PlayerHistory />} />
						<Route path="result-history" element={<ResultHistory />} />
						<Route path="turnover-report" element={<TurnoverReport />} />
						<Route path="bet-history" element={<BetHistory />} />
						<Route path="upi-payment-requests" element={<UPIPaymentRequests />} />
					</Route>
				</Route>
				<Route path="*" element={<Navigate to="/login" />} />
			</Routes>
			<GlobalCalls />
			<ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss={false} draggable={false} pauseOnHover theme="dark" />
		</BrowserRouter>
	);
}

export default App;
